export enum EThresholdLevel {
  LEVEL_4 = 'LEVEL_4', // Опасно
  LEVEL_3 = 'LEVEL_3', // Предупреждение
  LEVEL_2 = 'LEVEL_2', // Допустимо
  LEVEL_1 = 'LEVEL_1', // Хорошо
  LEVEL_0 = 'LEVEL_0', // Неопределённое
  NONE = 'NONE' // Не задан
}

export const mapThresholdLabel: Readonly<Record<EThresholdLevel, string>> = {
  [EThresholdLevel.NONE]: 'Не задан',
  [EThresholdLevel.LEVEL_0]: 'Неопределённое',
  [EThresholdLevel.LEVEL_1]: 'Хорошо',
  [EThresholdLevel.LEVEL_2]: 'Допустимо',
  [EThresholdLevel.LEVEL_3]: 'Предупреждение',
  [EThresholdLevel.LEVEL_4]: 'Опасно'
}
